// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-toolbar flat>
        <v-btn @click="$emit('delete-field')" icon><v-icon>clear</v-icon></v-btn>
        <v-toolbar-title>Webhook Field</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="formValid" ref="form">
          <v-row wrap>
            <v-col col="4" md="4">
              <v-select
                label="Local Field"
                :items="localFields"
                v-model="field.localField"
                :rules="[ruleRequired]"
              ></v-select>
            </v-col>
            <v-col col="4" md="4">
              <v-text-field
                name="remoteField"
                label="Remote Field Name"
                v-model="field.remoteFieldName"
                :rules="[ruleRequired]"
              ></v-text-field>
            </v-col>
            <v-col v-if="customString" col="4" md="4">
              <v-text-field
                name="remoteField"
                label="Custom String Value"
                v-model="field.stringValue"
                :rules="[ruleRequired]"
              ></v-text-field>
            </v-col>
            <v-col v-if="filterable" col="4" md="4">
              <v-checkbox
                name="invertFilters"
                label="Invert Filters"
                v-model="field.invertFilters"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="filterable" wrap>
            <v-col col="4" md="4">
              <v-text-field
                name="remoteField"
                label="Filter Prefix"
                v-model="field.filterPrefix"
              ></v-text-field>
            </v-col>
            <v-col col="4" md="4">
              <v-text-field
                name="remoteField"
                label="Filter Suffix"
                v-model="field.filterSuffix"
              ></v-text-field>
            </v-col>
            <v-col col="4" md="4">
              <v-text-field
                name="remoteField"
                label="Filter Regex"
                v-model="field.filterRegex"
              ></v-text-field>
            </v-col>
            <v-col v-for="(value, i) in field.filterValidValues" :key="i" col="4" md="4">
              <v-text-field
                name="remoteField"
                label="Filter Valid Value"
                v-model="field.filterValidValues[i]"
                append-outer-icon="delete"
                @click:append-outer="removeValidValue(i)"
              ></v-text-field>
            </v-col>
            <v-col col="12" md="12">
              <v-btn @click="addValidValue()">
                Add Valid Value
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import {ENDPOINT} from '@/shared/constants'
  import Rules from 'vue-common/components/rules'

  export default {
    props: {
      field: Object
    },

    data () {
      return {
        endpoint: ENDPOINT,
        localFields: [
          {
            text: 'Photo ID',
            value: 'photoID'
          },
          {
            text: 'Category Names',
            value: 'categoryNames'
          },
          {
            text: 'Tags',
            value: 'tags'
          },
          {
            text: 'Timestamp',
            value: 'timestamp'
          },
          {
            text: 'Uploader',
            value: 'uploader'
          },
          {
            text: 'Location',
            value: 'location'
          },
          {
            text: 'Comment',
            value: 'comment'
          },
          {
            text: 'Download Link',
            value: 'downloadLink'
          },
          {
            text: 'Encoded Image',
            value: 'encodedImage'
          },
          {
            text: 'Custom String',
            value: 'customString'
          }
        ],
        formValid: null
      }
    },

    created () {
    },

    computed: {
      filterable: function () {
        return this.field.localField === 'tags' || this.field.localField === 'categoryNames'
      },
      customString: function () {
        return this.field.localField === 'customString'
      }
    },

    methods: {
      ruleRequired: function (x) {
        return Rules.required(x)
      },
      removeValidValue: function (i) {
        this.field.filterValidValues.splice(i, 1)
      },
      addValidValue: function () {
        this.field.filterValidValues.push('')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// WebhookFieldEdit.vue?6a86ae10